import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../../../../../../tornado/icon/icon.component';
import { getInitialStyle, defaultContext, getCSAIconViewBox } from '../../metadataTitle.style';
import connect from './metadataTitle.connector';

export class MetadataTitle extends Lightning.Component {
  static _template() {
    return _merge(
      {
        FlexContainer: {
          Title: {},
          CsaIcon: {
            type: Icon,
          },
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._csaPicto = null;
    this._hasAgeGate = false;
  }

  _attach() {
    this._unsubscribe = connect(this);
  }

  _detach() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }

  set title(value) {
    this.tag('Title').text = value;
  }

  get title() {
    return this.tag('Title').text;
  }

  set csaPicto(value) {
    this._csaPicto = value;
    this.tag('CsaIcon').visible = Boolean(this._csaPicto);

    this.patch({
      FlexContainer: {
        CsaIcon: {
          visible: true,
          iconData: {
            picto: this._csaPicto,
            viewBox: getCSAIconViewBox(this._style.screenSize),
          },
        },
      },
    });
  }
}
